module.exports = __webpack_public_path__ + "assets/img/ko-59f9d940.png";